<template>
  <NuxtLayout>
    <Error4xx
      v-if="is4XX"
      :button-route="resolveLocalizedRoute({ name: HOME })"
      :error
    />
    <Error500 v-if="!is4XX" :error />
  </NuxtLayout>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app'
import { computed } from 'vue'

import Error4xx from '@backmarket/nuxt-layer-base/components/Error4xx/Error4xx.vue'
import Error500 from '@backmarket/nuxt-layer-base/components/Error500/Error500.vue'

import { useRouteLocationWithLocale } from '~/composables/useRouteLocationWithLocale'
import { HOME } from '~/scopes/home/route-names'

const resolveLocalizedRoute = useRouteLocationWithLocale()

const props = defineProps<{ error: NuxtError }>()

const is4XX = computed(() => [404, 410, 422].includes(props.error.status ?? 0))
</script>
